export const IMAGE_CDN_URL =
  "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";

export const MENU_IMAGE_ITEM_URL =
  "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/";

export const CROUSEL_IMAGE_CDN_URL =
  "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_520,h_520/";

export const RESTAURANT_MENU_URL = "https://food-villa-server.vercel.app/api/restaurant/menu?&lat=27.8973944&lng=78.0880129&menuId="

export const SWIGGY_RESTAURANT_CDN_URL =
  "https://food-villa-server.vercel.app/api/restaurants?lat=28.4594965&lng=77.0266383"
export const SITE_LOGO =
  "https://lh3.googleusercontent.com/Em7AHf7XBH_RtGfCBVXz9RH8SM_pHkj3xPP-yd3cRguY1_Jc8fmqgx6WxnvGVyPV5xs5gL3HCD0FCuv6Xo4CwoY6ak4";
